/**
 * Ruwe geografische centra (lon, lat) voor ISO 3166-1 alpha-2.
 * Gebruikt voor markers op de Europakaart (naast echte landgrenzen).
 */
export const EUROPE_CENTROIDS = {
  AL: [20.17, 41.15],
  AD: [1.52, 42.51],
  AT: [14.55, 47.52],
  BY: [28.05, 53.71],
  BE: [4.47, 50.50],
  BA: [17.68, 43.92],
  BG: [25.49, 42.73],
  HR: [15.2, 45.1],
  CY: [33.43, 35.13],
  CZ: [15.47, 49.82],
  DK: [9.5, 56.26],
  EE: [25.01, 58.60],
  FI: [25.75, 61.92],
  FR: [2.21, 46.23],
  DE: [10.45, 51.16],
  GR: [21.82, 39.07],
  HU: [19.50, 47.16],
  IS: [-18.11, 64.96],
  IE: [-8.24, 53.41],
  IT: [12.57, 41.87],
  XK: [20.90, 42.56],
  LV: [24.60, 56.88],
  LI: [9.56, 47.14],
  LT: [23.88, 55.17],
  LU: [6.13, 49.82],
  MT: [14.38, 35.94],
  MD: [28.37, 47.41],
  MC: [7.42, 43.74],
  ME: [19.26, 42.71],
  NL: [5.29, 52.13],
  MK: [21.75, 41.61],
  NO: [8.47, 60.47],
  PL: [19.13, 51.92],
  PT: [-8.22, 39.40],
  RO: [24.97, 45.94],
  SM: [12.46, 43.94],
  RS: [20.92, 44.02],
  SK: [19.70, 48.67],
  SI: [14.82, 46.12],
  ES: [-3.75, 40.46],
  SE: [18.64, 60.13],
  CH: [8.23, 46.82],
  UA: [31.17, 48.38],
  GB: [-3.44, 55.38],
  VA: [12.45, 41.90],
  TR: [35.24, 38.96],
  GE: [43.36, 42.32],
  AM: [44.93, 40.07],
  AZ: [47.58, 40.14],
  RU: [37.62, 55.75],
};
